import { render, staticRenderFns } from "./KeywordsGeneral.vue?vue&type=template&id=27fadae9&scoped=true"
import script from "./KeywordsGeneral.vue?vue&type=script&lang=js"
export * from "./KeywordsGeneral.vue?vue&type=script&lang=js"
import style0 from "./KeywordsGeneral.vue?vue&type=style&index=0&id=27fadae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fadae9",
  null
  
)

export default component.exports